import { render, staticRenderFns } from "./VeStuHealthScoreCount.vue?vue&type=template&id=408c2543&scoped=true"
import script from "./VeStuHealthScoreCount.vue?vue&type=script&lang=js"
export * from "./VeStuHealthScoreCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408c2543",
  null
  
)

export default component.exports